module.exports = __webpack_public_path__ + "static/media/spain.b0d5ad17.svg";